import { render, staticRenderFns } from "./tagFieldPicker.vue?vue&type=template&id=65910f2d&scoped=true"
import script from "./tagFieldPicker.vue?vue&type=script&lang=js"
export * from "./tagFieldPicker.vue?vue&type=script&lang=js"
import style0 from "./tagFieldPicker.vue?vue&type=style&index=0&id=65910f2d&prod&lang=scss"
import style1 from "./tagFieldPicker.vue?vue&type=style&index=1&id=65910f2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65910f2d",
  null
  
)

export default component.exports